import type { ReactNode } from 'react';
import { CharityOfChampions2026Banner } from '@/banners/charity-of-champions-2026/index.tsx';
import { useScrollReveal } from '@/hooks/useScrollReveal.ts';
import { Footer } from './Footer.tsx';
import { Nav } from './Nav.tsx';
import { ScrollTop } from './ScrollTop.tsx';

/**
 * Shared page chrome: skip link, nav, main landmark, footer, scroll-to-top.
 *
 * The scroll-reveal observer is registered here — once per page — instead of
 * in each page's script, which is what let the original accumulate duplicate
 * observers.
 *
 * The original preloader is intentionally NOT ported. It existed to mask the
 * unstyled flash of a render-blocking stylesheet; these pages are prerendered
 * with inlined critical markup, so a full-screen overlay would only delay LCP
 * and add a Lighthouse penalty for nothing.
 */
export function Layout({
  children,
  currentPath,
  navOnLight = false,
}: {
  children: ReactNode;
  currentPath: string;
  navOnLight?: boolean;
}) {
  useScrollReveal();

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to main content
      </a>
      <Nav currentPath={currentPath} onLight={navOnLight} />
      <main id="main">{children}</main>
      <Footer />
      <ScrollTop />
      <CharityOfChampions2026Banner />
    </>
  );
}
